/**
 * Specifies the `weekStartDay` of a [ChartCategoryAxisItem]({% slug api_charts_chartcategoryaxisitem %}).
 */
export var WeekStartDay;

(function (WeekStartDay) {
  /**
   * Specifies Sunday as the first day of the week.
   */
  WeekStartDay[WeekStartDay["Sunday"] = 0] = "Sunday";
  /**
   * Specifies Monday as the first day of the week.
   */

  WeekStartDay[WeekStartDay["Monday"] = 1] = "Monday";
  /**
   * Specifies Tuesday as the first day of the week.
   */

  WeekStartDay[WeekStartDay["Tuesday"] = 2] = "Tuesday";
  /**
   * Specifies Wednesday as the first day of the week.
   */

  WeekStartDay[WeekStartDay["Wednesday"] = 3] = "Wednesday";
  /**
   * Specifies Thursday as the first day of the week.
   */

  WeekStartDay[WeekStartDay["Thursday"] = 4] = "Thursday";
  /**
   * Specifies Friday as the first day of the week.
   */

  WeekStartDay[WeekStartDay["Friday"] = 5] = "Friday";
  /**
   * Specifies Saturday as the first day of the week.
   */

  WeekStartDay[WeekStartDay["Saturday"] = 6] = "Saturday";
})(WeekStartDay || (WeekStartDay = {}));